import forEach from 'lodash/forEach';
import without from 'lodash/without';

type TEventType = string;
type TEventHandlerArguments = any[];
type TEventHandler<T extends TEventHandlerArguments> = (...args: T) => any;

const handlers: Record<TEventType, TEventHandler<any>[]> = {};

const off = <T extends TEventHandlerArguments>(event: TEventType, handler: TEventHandler<T>) => {
  handlers[event] = without(handlers[event], handler);
};

const on = <T extends TEventHandlerArguments>(event: TEventType, handler: TEventHandler<T>) => {
  const eventHandlers = handlers[event];

  handlers[event] = Array.isArray(eventHandlers) ? [...eventHandlers, handler] : [handler];

  return () => off(event, handler);
};

const trigger = <T extends TEventHandlerArguments>(event: TEventType, ...args: T) =>
  forEach(handlers[event], (handler) => handler(...args));

export default {on, off, trigger};
